export default function AcessoContador() {
  return (
    <div className="w-full" style={{ height: 'calc(100vh - 80px)' }}>
      <iframe
        src="https://portalcontador.quantumsistemas.com.br/login.html"
        title="Portal do Contador"
        className="w-full h-full border-0"
        allow="fullscreen"
      />
    </div>
  )
}
